module.exports = __webpack_public_path__ + "images/178_320.jpg";